export default class BasePayload {
  public readonly event: string;
  public readonly id: string;

  constructor(event: string, id: string) {
    this.event = event;
    this.id = id;
  }
}
